export const CATALOGUE_LOCKED_COLUMN_KEYS = ['title', 'action', 'addToBasket']

export const CATALOGUE_OPTIONAL_COLUMN_DEFS = [
  { key: 'cloudinaryImageId', label: 'Image' },
  { key: 'size', label: 'Size' },
  { key: 'price', label: 'Price', requiresPrice: true },
  { key: 'UoM', label: 'UoM' },
  { key: 'pricedBy', label: 'Priced by' },
  { key: 'supplier.title', label: 'Supplier' },
  { key: 'sku', label: 'SKU' },
  { key: 'GLN', label: 'GLN', requiresGln: true },
  { key: 'type', label: 'Type' },
]

const prefsKey = venueId =>
  `oms.catalogue.hiddenColumns.${String(venueId || '').trim()}`

export const isCatalogueColumnLocked = key =>
  CATALOGUE_LOCKED_COLUMN_KEYS.includes(String(key || ''))

export const catalogueColumnLabel = column => {
  const key = String(column?.key || '')
  const fromDefs = CATALOGUE_OPTIONAL_COLUMN_DEFS.find(item => item.key === key)
  if (fromDefs?.label) return fromDefs.label
  if (typeof column?.title === 'string' && column.title.trim()) {
    return column.title.trim()
  }
  return key
}

export const listCatalogueOptionalColumns = (
  columns = CATALOGUE_OPTIONAL_COLUMN_DEFS,
  { showPrice = true, showGln = true } = {},
) =>
  (Array.isArray(columns) ? columns : [])
    .filter(column => {
      if (!column?.key || isCatalogueColumnLocked(column.key)) return false
      if (column.requiresPrice && !showPrice) return false
      if (column.requiresGln && !showGln) return false
      return true
    })
    .map(column => ({
      key: String(column.key),
      label: catalogueColumnLabel(column),
    }))

export const loadCatalogueHiddenColumns = venueId => {
  if (typeof window === 'undefined' || !window.localStorage) return null
  try {
    const raw = window.localStorage.getItem(prefsKey(venueId))
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return null
    return parsed.map(String).filter(key => !isCatalogueColumnLocked(key))
  } catch (error) {
    return null
  }
}

export const saveCatalogueHiddenColumns = (venueId, hiddenKeys = []) => {
  if (typeof window === 'undefined' || !window.localStorage) return
  const next = (Array.isArray(hiddenKeys) ? hiddenKeys : [])
    .map(String)
    .filter(key => !isCatalogueColumnLocked(key))
  window.localStorage.setItem(prefsKey(venueId), JSON.stringify(next))
}

export const toggleCatalogueHiddenColumn = (hiddenKeys, columnKey) => {
  const key = String(columnKey || '')
  if (!key || isCatalogueColumnLocked(key)) {
    return Array.isArray(hiddenKeys) ? [...hiddenKeys] : []
  }
  const current = new Set(
    (Array.isArray(hiddenKeys) ? hiddenKeys : []).map(String),
  )
  if (current.has(key)) current.delete(key)
  else current.add(key)
  return [...current]
}

export const filterCatalogueVisibleColumns = (
  columns = [],
  { hiddenKeys } = {},
) => {
  const list = (Array.isArray(columns) ? columns : []).filter(
    column => column && column.key,
  )
  if (!Array.isArray(hiddenKeys)) {
    return list
  }
  const hidden = new Set(hiddenKeys.map(String))
  return list.filter(
    column =>
      isCatalogueColumnLocked(column.key) || !hidden.has(String(column.key)),
  )
}
